exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\r\ntable.dataTable tbody th, table.dataTable tbody td {\r\n     padding: 0px 0px\r\n}\r\n\r\n/* center text */\r\ntable.dataTable tbody td {\r\n    vertical-align: middle;\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./ClientApp/css/datables-customizations.css
// module id = 113
// module chunks = 0